import { Outlet } from "react-router";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { setUser } from "../app/userSlice";
import PublicFooter from "../features/footer/PublicFooter";
import PublicHeader from "../features/header/PublicHeader";
import Header from "../features/header/Header";
import Footer from "../features/footer/Footer";
import { useGetSelfMutation } from "../features/users/usersApiSlice";

export default function Public(props: any) {
	const { isLoggedIn, username } = useAppSelector((state) => state.user);
	const onStatus = window.location.pathname.includes(`/status`);

	const dispatch = useAppDispatch();

	const [callGetSelf] = useGetSelfMutation();

	useEffect(() => {
		if (isLoggedIn && !username) {
			callGetSelf()
				.unwrap()
				.then((payload) => {
					dispatch(setUser({ ...payload }));
				})
				.catch((error: any) => {
					console.log(error);
				});
		}
	}, [isLoggedIn]);

	return (
		<div className="flex flex-col min-h-screen">
			{isLoggedIn && onStatus ? <Header /> : <PublicHeader />}
			<main className="mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8 w-screen">
				<Outlet />
			</main>
			{isLoggedIn && onStatus ? <Footer /> : <PublicFooter />}
		</div>
	);
}
